import gql from 'graphql-tag'
import { EntityFields } from '..'

export const InspectionAssessmentOptionFragment = gql`
  fragment InspectionAssessmentOption on purchase_inspection_assessment_option{
    ${EntityFields}
    name
  }
`
